import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html'
})
export class SpinnerComponent {


  @Input() type: string = "inside-text"
  @Input() visible: boolean = false;

  constructor() {
    // This is intentional
  }

}